import React from 'react'
import { wwwRoot } from '@liepin/js-core4c-fe';
import { Menu } from 'antd';

const CampusSubMenu: React.FC = () => (
  <Menu>
    <Menu.Item key="header-nav-menu-campus-home">
      <a
        id="header-nav-menu-campus-home"
        href={`${wwwRoot}/campus/`}
      >
        校园首页
      </a>
    </Menu.Item>
    <Menu.Item key="header-nav-menu-campus-famous-recruite">
      <a
        id="header-nav-menu-campus-famous-recruite"
        target="_blank"
        href={`${wwwRoot}/campus/comp-list/`}
      >
        2022校招网申
      </a>
    </Menu.Item>
    <Menu.Item key="header-nav-menu-campus-offline-broadcase">
      <a
        id="header-nav-menu-campus-offline-broadcase"
        target="_blank"
        href={`${wwwRoot}/campus/recruit-list/`}
      >
        线下宣讲会
      </a>
    </Menu.Item>
    <Menu.Item key="header-nav-menu-campus-live-list">
      <a
        id="header-nav-menu-campus-live-list"
        target="_blank"
        href={`${wwwRoot}/campus/live-list/`}
      >
        空中宣讲会
      </a>
    </Menu.Item>
  </Menu>
)

export default CampusSubMenu
